import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useLoader } from "../../components/loader/loader";
import { ApiUrl } from "../../config/apiConfig";
import { postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import {
  OnlyEnterNumber,
  isEmptyString,
  showAPiError_mesage,
} from "../../services/validationService/validationservice";
import Modal from "react-modal";
import pluseicon from "./../../assets/img/close-circle.svg";

import PhoneInput from "react-phone-input-2";
import Addresscomponet from "../../components/Addresscomponet";
interface AddTruckProps {
  isOpen: boolean;
  openModal: any;
  closeModal: () => void;
  getDataALLs?: () => void;
  selectedPriorities?: any
}
const AddBroker = React.forwardRef((props: AddTruckProps, ref) => {


  const { isOpen, openModal, closeModal } = props;
  const { show, hide } = useLoader();
  const refd: any = useRef(null);

  useEffect(() => {
    if (isOpen && openModal) {
      patchData(openModal);
    }
  }, [isOpen, openModal]);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      overflow: "unset !important",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !important",
      padding: "0 !important",
      border: "none !important",
    },
  };

  const [formData, setFormData] = useState<any>({
    company_name: "",
    mc_number: "",
    dot_number: "",
    carrierSetup: null,
    loadBoard: null,
    website_url: null,
    linkedin: null,
    facebook: null,
    xcom: null,
    instagram: null,
    physical_address: {
      DropDownmanualAddress: "",
      manualAddress: "",
    },
    // country_code: "",
    contact_information: [
      {
        phone_number: "",

      },
    ],
    showOnTop: false,
    priority: 9999
  });

  const [error, setError] = useState<any>({});

  const normalizeAddress = (value: any) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") {
      return value.manualAddress || value.DropDownmanualAddress || "";
    }
    return String(value);
  };

  const patchData = (data: any) => {
    const savedAddress = normalizeAddress(data?.physical_address);

    setFormData({
      company_name: data.company_name || "",
      contact_information: data?.contact_information?.map?.((val: any) => ({

        phone_number: val.phone_number || "",
      })) || [{ phone_number: "" }],
      mc_number: data.mc_number || "",
      dot_number: data.dot_number || "",

      physical_address: {
        DropDownmanualAddress: savedAddress,
        manualAddress: savedAddress,
      },
      carrierSetup: data.carrierSetup ? data.carrierSetup : null,
      loadBoard: data.loadBoard ? data.loadBoard : null,
      website_url: data.website_url ? data.website_url : null,
      linkedin: data.linkedin ? data.linkedin : null,
      facebook: data.facebook ? data.facebook : null,
      xcom: data.xcom ? data.xcom : null,
      instagram: data.instagram ? data.instagram : null,
      showOnTop: data.showOnTop ? data.showOnTop : false,
      priority: data.priority ? data.priority : 9999
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
      contact_information: [{ ...prev.contact_information[0] }],
    }));
    setError((prev: any) => ({ ...prev, [name]: "" }));
  };

  const handlePhoneChange = (phoneNumber: string, country: any) => {
    setFormData((prev: any) => ({
      ...prev,
      contact_information: [
        {
          ...prev.contact_information[0],
          phone_number: phoneNumber,
        },
      ],

    }));
    setError((prev: any) => ({ ...prev, phone_number: phoneNumber ? "" : prev.phone_number }));

  };



  const hideErrorCustomer = () => {
    resetForm();
    setError((prevErrors: any) => {
      const newErrors = { ...prevErrors };
      delete newErrors.company_name;
      delete newErrors.phone_number;
      delete newErrors.country_code;
      delete newErrors.mc_number;
      delete newErrors.dot_number;
      delete newErrors.physical_address;

      if (newErrors.contact_information && Array.isArray(newErrors.contact_information)) {
        newErrors.contact_information[0] = {
          ...newErrors.contact_information[0],
          phone_number: undefined,
        };
      }
      return newErrors;
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      [46, 8, 9, 27, 13, 37, 38, 39, 40].includes(e.keyCode) ||
      (e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode)) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    if (
      e.shiftKey ||
      e.keyCode < 48 || e.keyCode > 57 &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  };

  const handleKeyDownSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " " && (e.target as HTMLInputElement).value.length === 0) {
      e.preventDefault();
    }
  };

  const save = async () => {
    console.log('data', formData);
    let isValid = true;

    const error: { [key: string]: string } = {};
    const regexdot_number = /^[0-9]*$/;
    const addressValue = normalizeAddress(formData?.physical_address);

    formData.mc_number = formData.mc_number.trim();
    formData.dot_number = formData.dot_number.trim();


    if (!formData.company_name) {
      error.company_name = "Required";
      isValid = false;
    }
    if (!addressValue) {
      error.physical_address = "Required";
      isValid = false;
    }




    if (!formData.contact_information[0].phone_number) {
      console.log(!formData.contact_information[0].phone_number, 'addddddddddddd')

      error.phone_number = "Required";
      isValid = false;
    }






    if (!formData.dot_number) {
      error.dot_number = "Required";
      isValid = false;
    } else if (!regexdot_number.test(formData.dot_number)) {
      error.dot_number = "Only numbers are allowed.";
      isValid = false;
    }


    if (!formData.mc_number) {
      error.mc_number = "Required";
      isValid = false;
    } else if (!regexdot_number.test(formData.mc_number)) {
      error.mc_number = "Only numbers are allowed.";
      isValid = false;
    }

    // const upperCaseValue_lincense_number =formData.mc_number?.toUpperCase() || "";
    // const regex_lincense_number = /^[A-Z0-9\s]*$/;

    // const hasLetters_lincense_number = /[A-Z]/.test( upperCaseValue_lincense_number
    // );
    // const hasNumbers_lincense_number = /\d/.test(
    //   upperCaseValue_lincense_number
    // );

    // if (!formData.mc_number) {
    //   error.mc_number = "Required";
    //   isValid = false;
    // } else if (!regex_lincense_number.test(upperCaseValue_lincense_number)) {
    //   error.mc_number = "Only alphabets and numbers are allowed.";
    //   isValid = false;
    // } else if (!hasLetters_lincense_number) {
    //   error.mc_number = "Input must contain at least one alphabets.";
    //   isValid = false;
    // } else if (!hasNumbers_lincense_number) {
    //   error.mc_number = "Input must contain at least one number.";
    //   isValid = false;
    // }







    setError(error);
    if (isValid) {
      const payload = {
        ...formData,
        physical_address: addressValue,
        _id: openModal?._id,
      };

      try {
        const url = openModal?._id ? ApiUrl.addEditBroker : ApiUrl.addEditBroker;
        const response = await postData(url, payload, { show, hide });

        const messageServicesd = messageService();
        messageServicesd.toast(
          'success',
          openModal?._id ? messageServicesd.message.updatedSuccess : messageServicesd.message.addedSuccess
        );

        closeModal();
        resetForm();
        getDataALLs();

        if (response?.error?.message) {
          const MessageStore = response?.error?.message;
          showAPiError_mesage(MessageStore);
        }
      } catch (err: any) {
        if (err.response.data.message) {
          const MessageStore = err.response.data.message;
          showAPiError_mesage(MessageStore);
        }
      }
    }
  };

  const resetForm = () => {
    setFormData({
      company_name: "",
      contact_information: [{ phone_number: "" }],
      mc_number: "",
      dot_number: "",
      physical_address: {
        DropDownmanualAddress: "",
        manualAddress: "",
      },
    });
  };

  const getDataALLs = () => {
    props.getDataALLs?.();
    refd.current?.getDataALLs();
  };

  useImperativeHandle(ref, () => ({
    hideErrorCustomer: hideErrorCustomer,
  }));



  const handlePlaceSelectedCity = (place: google.maps.places.PlaceResult) => {
    if (place && place.formatted_address) {

      setFormData((prevData: any) => ({
        ...prevData,
        physical_address: {
          DropDownmanualAddress: place?.formatted_address,
          manualAddress: place?.formatted_address,
        },
      }));
      setError((prev: any) => ({ ...prev, physical_address: place.formatted_address ? "" : prev.physical_address }));

    } else {
      console.error("City name not found in address components");
    }
  };

  const handleChangef = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    setFormData((prevData: any) => ({
      ...prevData,
      physical_address: {
        ...(prevData.physical_address || {}),
        manualAddress: value,
        DropDownmanualAddress: value,
      },
    }));
    setError((prev: any) => ({ ...prev, physical_address: value ? "" : prev.physical_address }));

  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Add Broker Modal"
      ariaHideApp={false}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="bg-white !w-[30rem] rounded-lg  max-w-2xl shadow-xl">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">
            {openModal._id ? "Edit Broker" : "Add Broker"}
          </h2>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={() => {
              resetForm();
              closeModal();
            }}
            aria-label="Close"
          >
            <img src={pluseicon} alt="Close" />
          </button>
        </div>

        <div className="space-y-2 p-4">

          {/* Company Name */}
          <div>
            <input
              type="text"
              placeholder="Company Name"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.company_name}
              name="company_name"
              onChange={handleChange}
              onKeyDown={handleKeyDownSpace}
            />
            {error.company_name && <div className="text-red-500 text-sm">{error.company_name}</div>}
          </div>

          {/* Phone Number */}
          <div>
            <PhoneInput
              inputClass="w-full p-2 text-md  focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] border border-red-300 rounded-md bg-white  outline-[1px] transition-all duration-500 "
              containerClass="w-full p-1   text-md border border-gray-300 rounded-md bg-white  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              country={"us"}
              value={formData.contact_information[0]?.phone_number}
              onChange={handlePhoneChange}
              disableDropdown
              countryCodeEditable={true}
            />
            {error.phone_number && <div className="text-red-500 text-sm">{error.phone_number}</div>}
          </div>

          <div className="mt-5">
            <select
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              name="adminType"
              value={formData.priority}
              onChange={(e) => {
                const value = e.target.value;
                if (!isEmptyString(value)) {
                  setFormData((prev: any) => ({ ...prev, priority: Number(value) }))
                }
              }}
            >
              <option value={9999} disabled selected>Select Priority</option>             
              {Array.from({ length: 50 }, (_, index) => index + 1).map((num) => (
                <option disabled={props?.selectedPriorities?.includes(num)} key={num} value={num}>
                  {num}
                </option>
              ))}

            </select>
          </div>

          {/* MC Number */}
          <div>
            <input
              type="text"
              placeholder="MC Number"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] "
              value={formData.mc_number}
              name="mc_number"
              onChange={handleChange}
              onKeyDown={OnlyEnterNumber}
            />
            {error.mc_number && <div className="text-red-500 text-sm">{error.mc_number}</div>}
          </div>

          {/* Website */}
          <div>
            <input
              type="text"
              placeholder="Website"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.website_url}
              name="website_url"
              onChange={handleChange}
            />
          </div>

          {/* Carrier Setup */}
          <div>
            <input
              type="text"
              placeholder="Carrier Setup"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.carrierSetup}
              name="carrierSetup"
              onChange={handleChange}
            />
          </div>

          {/* Load Board */}
          <div>
            <input
              type="text"
              placeholder="Load Board"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.loadBoard}
              name="loadBoard"
              onChange={handleChange}
            />
          </div>

          {/* DOT Number */}
          <div>
            <input
              type="text"
              placeholder="DOT Number"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.dot_number}
              name="dot_number"
              onChange={handleChange}
              onKeyDown={OnlyEnterNumber}
            />
            {error.dot_number && <div className="text-red-500 text-sm">{error.dot_number}</div>}
          </div>
          {/* linkedin */}
          <div>
            <input
              type="text"
              placeholder="Linkedin"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.linkedin}
              name="linkedin"
              onChange={handleChange}
            />
          </div>
          {/* facebook */}
          <div>
            <input
              type="text"
              placeholder="Facebook"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.facebook}
              name="facebook"
              onChange={handleChange}
            />
          </div>
          {/* xcom */}
          <div>
            <input
              type="text"
              placeholder="X.com"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.xcom}
              name="xcom"
              onChange={handleChange}
            />
          </div>

          {/* instagram */}
          <div>
            <input
              type="text"
              placeholder="Instagram"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData.instagram}
              name="instagram"
              onChange={handleChange}
            />
          </div>



          {/* Address */}
          <div>
            <Addresscomponet
              title="Address Modal"
              value={formData?.physical_address?.manualAddress}
              name="physical_address"
              placeholder="Address"
              onChange={handleChangef}
              handlePlaceSelectedCity={handlePlaceSelectedCity}
            />
            {error.physical_address && <div className="text-red-500 text-sm">{error.physical_address}</div>}
          </div>






          {/* Save Button */}
          <div className="flex justify-end items-center pt-4 border-t">
            <button
              type="button"
              className="px-6 py-2 bg-customOrange text-white rounded-md  hover:bg-greenBg text-sm font-semibold  flex items-center justify-center ease-in-out duration-500 shadow-[1px_2px_2px_rgba(0,0,0,0.3)]"
              onClick={save}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </Modal >

  );
});


export default AddBroker;
